/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiResource } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '@irian-ro/util-environment';
import { CostCenterDTO } from '@well/delivery-libs/cost-center/domain';

@Injectable({
  providedIn: 'root',
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class CostCenterResourceService extends AbstractResourceService<any, any, any, any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('delCostCenterUrl'), undefined, undefined);
  }

  getDetails(uuid: string): Observable<JsonApiResource<CostCenterDTO, undefined>> {
    return this.httpClient?.get(`${this.url}/${uuid}`).pipe(this.getDtoMapper());
  }

  override save(costCenterDTO: CostCenterDTO): Observable<JsonApiResource<CostCenterDTO, undefined>> {
    return this.httpClient?.post(`${this.url}`, costCenterDTO).pipe(this.getDtoMapper());
  }

  delete(uuid: string): Observable<JsonApiResource<CostCenterDTO, undefined>> {
    return this.httpClient?.delete(`${this.url}/${uuid}`).pipe(this.getDtoMapper());
  }
}
